import { capitalizeStringUtil } from 'packages/src'

export function toLowerCaseStringUtil (str = '') {
  return str.toLowerCase()
}

/**
 * Converts the given `value` to a string.
 * @param  {String} value
 * @returns {String}
 */
export function fromSlugToString (value, separator = '') {
  return value
    .toLowerCase()
    .replace(/-/g, ' ')
}

export function getLastSegmentFromString (str = '', separator = '/') {
  if (typeof str !== 'string') {
    str = str + ''
  }
  const segments = str.split(separator)
  return segments[segments.length - 1]
}

export function joinStrReduxUtil (...strings) {
  return `${capitalizeStringUtil(strings.map(str => (
    str + ''
  )
    .replace(/_/g, ' '))
    .join(' '))}`
}
